/* DON'T EDIT THIS FILE: edit original and run build again */ import { TenantHandler } from "../../framework/tenant-handler-type/tenant-handler.ts";
import { getRealmUrlParts } from "./get-realm-url-parts.ts";

const getRealmHandlerUrlParts = (
  realmHandler: TenantHandler,
  configGetter?: () => any
) =>
  getRealmUrlParts(
    realmHandler.getCode(),
    realmHandler.getPathLabel(),
    configGetter
  );

export const getBaseRealmUrl = (
  realmHandler: TenantHandler,
  configGetter?: () => any
) => {
  const realmUrlParts = getRealmHandlerUrlParts(realmHandler, configGetter);
  const { protocol, hostname, port } = realmUrlParts;
  return protocol + "://" + hostname + (port ? ":" + port : "");
};

export const getRealmUrl = (
  realmHandler: TenantHandler,
  configGetter?: () => any
) => {
  const realmUrlParts = getRealmHandlerUrlParts(realmHandler, configGetter);
  const { protocol, hostname, port, pathname } = realmUrlParts;
  return (
    protocol +
    "://" +
    hostname +
    (port ? ":" + port : "") +
    (pathname ? pathname : "")
  );
};

export const getRealmHostname = (
  realmHandler: TenantHandler,
  configGetter?: () => any
) => getRealmHandlerUrlParts(realmHandler, configGetter).hostname;
